module.exports = __webpack_public_path__ + "img/benchmark_results.d02152ba.png";